export default "__VITE_ASSET__Crad_cSw__"